import { apiSlice } from "../_api/api-slice";

interface User {
  language?: string;
  [key: string]: any;
}

export const user = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getMyUser: build.query<User, string>({
      query: () => ({
        url: `myuser`,
        method: "get",
      }),
    }),
  }),

  overrideExisting: false,
});

export const { useGetMyUserQuery } = user;